<template>
  <!-- What is missing, right under the field it belongs to (#860). -->
  <p v-if="message" class="ic-form-issue" role="alert" :data-testid="testId">{{ message }}</p>
</template>

<script>
export default {
  name: "FormIssue",
  props: {
    message: { type: String, default: "" },
    testId: { type: String, default: "form-issue" },
  },
};
</script>

<style>
/* Not scoped: the highlight goes on the field's wrapper, which belongs to the
   form using this component. */
.ic-form-issue {
  margin-top: 6px;
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  color: #d64545;
}
.ic-form-issue-target {
  border-radius: 10px;
  outline: 2px solid #e55b5b;
  outline-offset: 4px;
  background: rgba(229, 91, 91, 0.05);
  scroll-margin: 96px;
}
</style>
